/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ArrayOfGraceDocumentsStatus model module.
 * @module model/ArrayOfGraceDocumentsStatus
 * @version 2.0.0
 */
class ArrayOfGraceDocumentsStatus {
    /**
     * Constructs a new <code>ArrayOfGraceDocumentsStatus</code>.
     * @alias module:model/ArrayOfGraceDocumentsStatus
     */
    constructor() { 
        
        ArrayOfGraceDocumentsStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ArrayOfGraceDocumentsStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ArrayOfGraceDocumentsStatus} obj Optional instance to populate.
     * @return {module:model/ArrayOfGraceDocumentsStatus} The populated <code>ArrayOfGraceDocumentsStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ArrayOfGraceDocumentsStatus();

            if (data.hasOwnProperty('pending')) {
                obj['pending'] = ApiClient.convertToType(data['pending'], 'String');
            }
            if (data.hasOwnProperty('sent')) {
                obj['sent'] = ApiClient.convertToType(data['sent'], 'String');
            }
            if (data.hasOwnProperty('validated')) {
                obj['validated'] = ApiClient.convertToType(data['validated'], 'String');
            }
            if (data.hasOwnProperty('refused')) {
                obj['refused'] = ApiClient.convertToType(data['refused'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} pending
 */
ArrayOfGraceDocumentsStatus.prototype['pending'] = undefined;

/**
 * @member {String} sent
 */
ArrayOfGraceDocumentsStatus.prototype['sent'] = undefined;

/**
 * @member {String} validated
 */
ArrayOfGraceDocumentsStatus.prototype['validated'] = undefined;

/**
 * @member {String} refused
 */
ArrayOfGraceDocumentsStatus.prototype['refused'] = undefined;






export default ArrayOfGraceDocumentsStatus;

